var SortedMap = require("../collections/sortedMap.js");
var getSetFunctionCreator = require("./getsetFunction.js");
var sanityCheckHandler = require("./sanityCheckHandler.js");

// ObservableValue class: creates ObservableValue instances with separate getter and setter functions
var ObservableValue = function(validator){
    this._value = null;

    if (typeof validator == "function") this.validator = validator;

    this.handlers = {
        change: null,
        setFail: null,
        setPass: null
    };
};

// ObservableValue function creator: creates a new ObservableValue function instance that combines a getter and setter, this function has the same properties and interface as an ObservableValue instance
ObservableValue.createNewFunction = getSetFunctionCreator;

ObservableValue.prototype.getType = function(){return "value"};

ObservableValue.prototype.get = function(){
    return this._value;
};

ObservableValue.prototype.set = function(val){
    if (val !== this._value){
        var self = this;
        var prevValue = this._value;
        var validated = !this.validator || this.validator(val, prevValue);
        if(validated) {
            this._value = val;
            this.handlers.change && this.handlers.change.forEach(function(k, handler){
                handler.call(self, val, prevValue);
            });
        } else {
            this.handlers.setFail && this.handlers.setFail.forEach(function(k, handler){
                handler.call(self, val, prevValue);
            });
        }
        return validated;
    } else return true;
};

ObservableValue.prototype.onChange = function(key, handler, priority) {  // handlers without priority get default priority 0 and are sorted in insertion order
    sanityCheckHandler(arguments);
    if(!this.handlers.change) this.handlers.change = new SortedMap();
    this.handlers.change.put(key, handler, priority || 0);
};

ObservableValue.prototype.onSetFail = function(key, handler, priority) {
    sanityCheckHandler(arguments);
    if(!this.handlers.setFail) this.handlers.setFail = new SortedMap();
    this.handlers.setFail.put(key, handler, priority || 0);
};

ObservableValue.prototype.onSetPass = function(key, handler, priority) {
    sanityCheckHandler(arguments);
    if(!this.handlers.setPass) this.handlers.setPass = new SortedMap();
    this.handlers.setPass.put(key, handler, priority || 0);
};

ObservableValue.prototype.removeHandlers = function(key){
    for (var type in this.handlers){
        if(this.handlers[type]) {
            this.handlers[type].remove(key);
            this._cleanHandlers(type);
        }
    }
};

ObservableValue.prototype.removeAllHandlers = function(col) {
    for (var type in this.handlers) {
        if(this.handlers[type]) {
            this.handlers[type].removeAll(col);
            this._cleanHandlers(type);
        }
    }
};

ObservableValue.prototype.removeHandlersWhere = function(f){
    for (var type in this.handlers){
        if(this.handlers[type]) {
            this.handlers[type].removeWhere(f);
            this._cleanHandlers(type);
        }
    }
};

ObservableValue.prototype._cleanHandlers = function(type) {
    if(this.handlers[type].size() == 0)
        this.handlers[type] = null;
};

module.exports = ObservableValue;